import React from 'react';
import { Col, List, Row, Space, Tag, Tooltip, Typography } from 'antd';
import dayjs from 'dayjs';

import Secondary from '../../../../../shared/ui/SecondaryText';
import { IEvent } from '../../../interfaces';

const { Text, Paragraph } = Typography;

interface Props {
    readonly source: {
        items: IEvent[];
    };
}
export const EventsCard = ({ source }: Props) => {
    return (
        <List
            dataSource={source.items}
            renderItem={event => (
                <List.Item>
                    <Space
                        direction={'vertical'}
                        style={{
                            width: '100%',
                        }}
                    >
                        <Row>
                            <Col span={12}>
                                <Text>{event.telegram_user}</Text>
                            </Col>

                            <Col span={12} style={{ textAlign: 'right' }}>
                                <Tooltip title={event.event}>
                                    <Paragraph
                                        style={{
                                            marginTop: '0',
                                            marginBottom: '0',
                                        }}
                                        ellipsis={{
                                            rows: 1,
                                        }}
                                    >
                                        <Secondary>{event.event}</Secondary>
                                    </Paragraph>
                                </Tooltip>
                            </Col>
                        </Row>

                        <Paragraph
                            strong
                            style={{ marginTop: '0', marginBottom: '0' }}
                            ellipsis={{
                                rows: 2,
                            }}
                        >
                            {event.community}
                        </Paragraph>

                        {event.community_tags.length === 0 ? null : (
                            <Secondary>
                                {event.community_tags.map((tag, index) => (
                                    <Tag key={index}>{tag.name}</Tag>
                                ))}
                            </Secondary>
                        )}

                        <Col span={24}>
                            <Secondary>
                                {dayjs(event.done_date).format(
                                    'DD.MM.YYYY, HH:mm'
                                )}
                            </Secondary>
                        </Col>
                    </Space>
                </List.Item>
            )}
        />
    );
};
